const http = require('live-mp-tools')
import {ENV_NAME} from "../libs/wxConfig";
// 客户端基础域名
const CLIENT_BASE_URL = `alive-client${ENV_NAME ? `.${ENV_NAME}` : ''}.xiaoeknow.com`
/**
 * ------------------- 接口api -------------------
 */
//  接口前缀
const gateway = (data = '_alive/') => (data);
// 发红包接口
const redPacketPay = (params, isNeedBiz = false, config = {}) => (
  http.player.post('v1/red_packet/pay', params, isNeedBiz, config,CLIENT_BASE_URL))
// 发红包列表接口
const getRedPacketList = (params, isNeedBiz = false, config = {}) => (
  http.player.post('_red_packet/get_red_packet_list', params, isNeedBiz, config,CLIENT_BASE_URL))
// 获取红包记录详情信息
const getRedPacketRecordDetail = (params, isNeedBiz = false, config = {}) => (
  http.player.post('_red_packet/get_red_packet_record', params, isNeedBiz, config,CLIENT_BASE_URL))
// 获取红包详情接口
const getRedPacketInfo = (params, isNeedBiz = false, config = {}) => (
  http.player.post('_red_packet/get_red_packet_info', params, isNeedBiz, config,CLIENT_BASE_URL))
// 红包IM超时重新发起接口
const checkSendRedPacket = (params, isNeedBiz = false, config = {}) => (
  http.player.post('_red_packet/check_send_red_packet', params, isNeedBiz, config,CLIENT_BASE_URL));
// 领取红包接口
const receiveRedPacket = (params, isNeedBiz = false, config = {}) => (
  http.player.post('_red_packet/receive_red_packet', params, isNeedBiz, config,CLIENT_BASE_URL))
// 支付组件API
const PAYMODULE = {
  GOPAY: `${gateway()}/pay/get_info_new`,
  QUERY_CALL_BACK:`${gateway()}/pay/query_call_back`
};
/**
 * ------------------- 封装接口请求 -------------------
 */

// 支付接口
const pay = (params, isNeedBiz = true, config = {}) => {
  return http.player.post(PAYMODULE.GOPAY, params, isNeedBiz, config);
}
// 查询支付结果
const query_call_back= (params, isNeedBiz = true, config = {}) => {
  return http.player.post(PAYMODULE.QUERY_CALL_BACK, params, isNeedBiz, config);
}
module.exports = {
  getRedPacketRecordDetail,
  redPacketPay,
  pay,
  query_call_back,
  getRedPacketList,
  getRedPacketInfo,
  receiveRedPacket,
  checkSendRedPacket
}
